import { render } from "./SectionOvertimeForm.vue?vue&type=template&id=476f52ae&scoped=true"
import script from "./SectionOvertimeForm.vue?vue&type=script&lang=js"
export * from "./SectionOvertimeForm.vue?vue&type=script&lang=js"

import "./SectionOvertimeForm.vue?vue&type=style&index=0&id=476f52ae&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476f52ae"]])

export default __exports__